"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderChannelEnum = void 0;
var OrderChannelEnum;
(function (OrderChannelEnum) {
    OrderChannelEnum["Online"] = "Online";
    OrderChannelEnum["BoxOffice"] = "Box Office";
})(OrderChannelEnum = exports.OrderChannelEnum || (exports.OrderChannelEnum = {}));
;
//# sourceMappingURL=OrderChannelEnum.js.map